export default function closeWindowOnFocusOutEventListener() {
  const closeWindowOnFocusOut = () => document.hidden && window.close();
  document.addEventListener("visibilitychange", closeWindowOnFocusOut);
}
